import React from 'react'
import {IconButton, Tooltip} from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
function TextFieldToolTip(props){
    const {text} = props;
    return (
        <Tooltip title={text}>
            <IconButton>
                <InfoIcon style={{color:"#3f51b5",paddingTop:0,paddingBottom:0,paddingLeft:0}}/>
            </IconButton>
        </Tooltip>
    )
}

export default TextFieldToolTip;